import { Component, ElementRef, Inject, ViewChild } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";


@Component({
    selector: 'confirm-dialog',
    templateUrl: 'confirm-dialog.component.html',
})

export class ConfirmDialog{
    @ViewChild('imageElement', { static: false })
    imageElement!: ElementRef<HTMLImageElement>;

    QRCode:any ='https://quickchart.io/chart?cht=qr&chs=100x100&chl='
    pageName:any;
    sub_event_member_id :any;
    constructor( public dialogRef: MatDialogRef<ConfirmDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {
    this.pageName = data.page;
    this.sub_event_member_id = data.sub_event_member_id;
    console.log('this.sub_event_member_id',this.sub_event_member_id);
    
    }
    onNoClick(num:any): void {
        this.dialogRef.close(num);
    }

    downloadImage() {
        const image = this.imageElement.nativeElement;
    
        // Create an XHR to fetch the image data
        const xhr = new XMLHttpRequest();
        xhr.open('GET', image.src, true);
        xhr.responseType = 'blob';
    
        xhr.onload = () => {
          const blob = xhr.response;
          const blobURL = URL.createObjectURL(blob);
    
          // Create a temporary anchor element
          const link = document.createElement('a');
          link.href = blobURL;
          link.download = 'આમંત્રણ-OR.png';
    
          // Append the anchor to the body and programmatically click it to trigger download
          document.body.appendChild(link);
          link.click();
    
          // Clean up: remove the anchor and revoke the blob URL from memory
          document.body.removeChild(link);
          URL.revokeObjectURL(blobURL);
        };
    
        xhr.send();
        this.onNoClick(0)
      }
  
}